import React, { Fragment, useState } from "react";
import Dropdown from "../components/form/Dropdown";
import Indentification from "../components/elements/Indentification";
import { initialsValue } from "../helpers";
import { useNavigate } from "react-router-dom";
import Modal from "../components/elements/Modal";
import Button from "../components/form/Button";

import LogoutModal from "../components/LogoutModal/LogoutModal";


const AuthDropdown = ({ user }) => {
  const navigate = useNavigate();
  const [isLogoutModelOpen, setIsLogOutModelOpen] = useState(false);
  const dropdownData = [
    {
      name: "Dashboard",
      icon: "fa-solid fa-table-cells", // Matches 2x2 grid icon
      standout: false,
      click: () => {
        navigate("/user/dashboard");
      },
    },
    {
      name: "Profile Information",
      icon: "fa-regular fa-clipboard", // Clipboard with text icon
      standout: false,
      click: () => {
        navigate("/user/profile");
      },
    },
    {
      name: "Applications",
      icon: "fa-solid fa-table-cells", // Same as dashboard icon in image
      standout: false,
      click: () => {
        navigate("/user/applications");
      },
    },
    {
      name: "Communications",
      icon: "fa-regular fa-comments", // Speech bubbles icon
      standout: false,
      click: () => {
        navigate("/user/communications");
      },
    },
    {
      name: "Resources",
      icon: "fa-regular fa-file", // Document/paper icon
      standout: false,
      click: () => {
        navigate("/user/resources");
      },
    },
    {
      name: "Logout",
      icon: "fa-solid fa-right-from-bracket", // Arrow-from-box icon
      standout: true,
      click: () => {
        setIsLogOutModelOpen(true);
        // localStorage.clear();
        // sessionStorage.clear();
        // navigate("/");
      },
    },
  ];

  return (
    <>
      <Dropdown
        data={dropdownData}
        buttonClasses={"!p-0 border-0"}
        button={
          <Indentification
            initial={initialsValue(`${user?.firstName} ${user?.lastName}`)}
            image={user?.image?.url || user?.image}
            size="sm"
          />
        }
        xPlacement="bottomRight"
      />

      <LogoutModal
        setIsOpen={(val) => setIsLogOutModelOpen(val)}
        isOpen={isLogoutModelOpen}
      />

    </>
  );
};

export default AuthDropdown;
